/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual leaderboard
// logic in a relevant structure within app/javascript and only use these pack
// files to reference that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'leaderboard' %> to the
// appropriate layout file, like app/views/layouts/leaderboard.html.erb

import 'regenerator-runtime/runtime';

import { get } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';

import { css, Global, ThemeProvider } from '@emotion/react';
import emotionNormalize from 'emotion-normalize';

import ScoredCarousel from './connected/carousel_scored';
import SortedCarousel from './connected/carousel_sorted';

// Bootstrap leaderboard
const leaderboard = {
  data: {
    attributes: Object.assign(
      {
        font: "'Proxima Nova', sans-serif",
        background_color: '#666',
        background_text_color: '#FFF',
        foreground_color: '#FFF',
        foreground_text_color: '#666',
        highlight_color: '#AAA',
        sorted: false,
        promo_page_timer: 8000,
        entries_page_timer: 8000,
        results_page_timer: 8000,
        winner_page_timer: 8000,
        randomise_results: false,
        randomise_results_count: 0,
        randomise_results_exclude_ids: [],
      },
      get(window.MP, 'LEADERBOARD.data.attributes', {})
    ),
  },
};

leaderboard.data.logo = get(window.MP, 'LEADERBOARD.data.links.logo');
leaderboard.data.backgroundImage = get(
  window.MP,
  'LEADERBOARD.data.links.background_image'
);
leaderboard.data.promoPages = get(
  window.MP,
  'LEADERBOARD.data.relationships.promo_pages',
  []
);

const theme = {
  font: leaderboard.data.attributes.font,
  display: leaderboard.data.attributes.display,
  backgroundColor: leaderboard.data.attributes.background_color,
  backgroundTextColor: leaderboard.data.attributes.background_text_color,
  foregroundColor: leaderboard.data.attributes.foreground_color,
  foregroundTextColor: leaderboard.data.attributes.foreground_text_color,
  highlightColor: leaderboard.data.attributes.highlight_color,
  logo: leaderboard.data.logo,
  backgroundImage: leaderboard.data.backgroundImage,
  promoPage: leaderboard.data.promoPage,
};

const globalStyles = theme => css`
  ${emotionNormalize}

  @font-face {
    font-family: 'Proxima Nova';
    src: url('${require('./assets/proxima-nova-alt-bold.otf')}')
      format('opentype');
  }

  html,
  body {
    ${theme.display === 'tv'
      ? `
    height: 1080px;
    width: 1920px;
  `
      : `
    height: 1280px;
    width: 1920px;
  `}
    overflow: hidden;
  }

  #main {
    ${theme.display === 'tv'
      ? `
    height: 1080px;
    width: 1920px;
  `
      : `
    height: 1280px;
    width: 1920px;
  `}

    font-family: ${theme.font};
    background-color: ${theme.backgroundColor};
    overflow: hidden;
    box-sizing: border-box;

    ${theme.backgroundImage
      ? `
      background-image: url(${theme.backgroundImage});
    `
      : null}
  }
`;

function Leaderboard() {
  console.log('Leaderboard', leaderboard);

  return (
    <ThemeProvider theme={theme}>
      <Global styles={globalStyles(theme)} />

      {leaderboard?.data?.attributes?.sorted ? (
        <SortedCarousel
          accessToken={window.MP.ACCESS_TOKEN}
          domain={window.MP.DOMAIN}
          eventId={window.MP.EVENT_ID}
          leaderboard={leaderboard}
        />
      ) : (
        <ScoredCarousel
          accessToken={window.MP.ACCESS_TOKEN}
          domain={window.MP.DOMAIN}
          eventId={window.MP.EVENT_ID}
          leaderboard={leaderboard}
        />
      )}
    </ThemeProvider>
  );
}

ReactDOM.render(<Leaderboard />, document.getElementById('main'));
